import { useState } from "react";
import "./WarehouseForm.css";
import axios from "../../service/axios";
import { toast } from "react-toastify";

import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { getLoggedInUser } from "../../utils/authUtils";

const WarehouseForm = ({ onDialogHandler, fetchWarehouses, warehouseData }) => {
  const userInfo = getLoggedInUser();

  const [formData, setFormData] = useState({
    warehouseName: null,
    warehouseCode: null,
  });
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (warehouseData) {
      setFormData({
        warehouseName: warehouseData.name || null,
        warehouseCode: warehouseData.code || null,
      });
    }
  }, [warehouseData]);
  //Is all fields are valid
  const isFieldsValid = formData.warehouseName && formData.warehouseCode;
  // change detction in Form
  const changeInForm = warehouseData?.name !== formData.warehouseName || warehouseData?.code !== formData.warehouseCode;
  const onFormSubmitHandler = (e) => {
    e.preventDefault();
    if (warehouseData) {
      onEditWarehouseHandler();
    } else {
      onCreateWarehouseHandler();
    }
  };

  const onCreateWarehouseHandler = async () => {
    setLoader(true);
    const payload = {
      name: formData.warehouseName,
      code: formData.warehouseCode,
    };
    try {
      const { data } = await axios.post(`warehouse-layout`, payload);
      //alert("Warehouse created successfully");
      fetchWarehouses();
      onDialogHandler();
      toast.success("Warehouse created successfully");
    } catch (error) {
      const {
        response: {
          data: { message },
        },
      } = error;
      const defaultErrorMessage = "Oops Something went wrong";
      toast.error(message || defaultErrorMessage);
      console.log("error", error);
    } finally {
      setLoader(false);
    }
  };

  const onEditWarehouseHandler = async () => {
    setLoader(true);
    const payload = {
      name: formData.warehouseName,
      code: formData.warehouseCode,
      stackenableWarehouseCode: userInfo?.warehouseCode,
    };

    try {
      const { data } = await axios.put(`warehouse-layout/${warehouseData?.id}`, payload);
      onDialogHandler(data?.data);
      toast.success(data?.message);
    } catch (error) {
      const {
        response: {
          data: { message },
        },
      } = error;
      const defaultErrorMessage = "Oops Something went wrong";
      toast.error(message || defaultErrorMessage);
    } finally {
      setLoader(false);
    }
  };
  const onCancelHandler = () => {
    onDialogHandler();
  };

  return (
     <div className="overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">{warehouseData?.name ? "Edit Layout" : "Create Layout"}</h2>
          <button className="close-button" type="button" onClick={onCancelHandler}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <form autoComplete="off" onSubmit={onFormSubmitHandler}>
          <div className="modal-body">
            <div className="form-group">
              <label className="form-label" htmlFor="warehouseName">
                Warehouse Name <span className="required">*</span>
              </label>
              <input
                type="text"
                id="warehouseName"
                name="warehouseName"
                className="form-input"
                value={formData.warehouseName}
                maxLength={20}
                placeholder="Enter warehouse name"
                onChange={e =>
                  setFormData({ ...formData, [e.target.id]: e.target.value })
                }
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="warehouseCode">
                Warehouse Code <span className="required">*</span>
              </label>
              <input
                type="text"
                id="warehouseCode"
                name="warehouseCode"
                className="form-input"
                value={formData.warehouseCode}
                maxLength={10}
                placeholder="Enter warehouse code"
                onChange={e =>
                  setFormData({
                    ...formData,
                    [e.target.id]: e.target.value.toUpperCase(),
                  })
                }
              />
            </div>

            <div className="button-group">
              <button type="button" className="button" onClick={onCancelHandler}>
                Cancel
              </button>
              <button
                type="submit"
                className="button button-primary"
                disabled={!isFieldsValid || !changeInForm || loader}
                style={{
                  backgroundColor: isFieldsValid && changeInForm
                    ? "#607ad6"
                    : "rgba(202, 197, 197, 0.681)",
                  color:
                    !isFieldsValid || !changeInForm
                      ? "grey"
                      : "white",
                  borderColor: isFieldsValid && changeInForm
                    ? "#607ad6"
                    : "#d1d5db",
                }}
              >
                {loader && (
                  <span>
                    <FontAwesomeIcon
                      icon={faCircleNotch}
                      className="loader-icon"
                      onClick={() => setDeleteElement(warehouse)}
                    />
                  </span>
                )}
                {warehouseData?.name ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
};

export default WarehouseForm;
